import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Details.css';
import PuzzleFact from '../PuzzleFact/PuzzleFact';

const EventInfo = ({ onViewMap }) => (
  <div className="event-info">
    <div className="event-info-group">
      <h3 className="event-info-subtitle">When</h3>
      <p className="event-info-text"><PuzzleFact factId="wedding-date" /></p>
    </div>

    <div className="event-info-group">
      <h3 className="event-info-subtitle">Where</h3>
      <p className="event-info-text"><PuzzleFact factId="venue" /></p>
      <p className="event-info-text"><PuzzleFact factId="address" /></p>
      <p className="event-info-text">SW1Y 5AH</p>
      <a href="/map" className="event-info-link" onClick={onViewMap}>View Map</a>
    </div>

    <div className="event-info-group">
      <h3 className="event-info-subtitle">Dress Code</h3>
      <p className="event-info-text"><PuzzleFact factId="decoy-dress-code" /></p>
    </div>
  </div>
);

const EventTimeline = () => (
  <div className="event-timeline">
    <h3 className="event-timeline-subtitle">Timeline</h3>
    <div className="event-timeline-items">
      <div className="event-timeline-item">
        <span className="event-timeline-label">Guest Arrival</span>
        <span className="event-timeline-time"><PuzzleFact factId="arrival-time" /></span>
      </div>
      <div className="event-timeline-item">
        <span className="event-timeline-label">Wedding Ceremony</span>
        <span className="event-timeline-time"><PuzzleFact factId="decoy-ceremony-time" /></span>
      </div>
      <div className="event-timeline-item">
        <span className="event-timeline-label">Drinks Reception</span>
        <span className="event-timeline-time">4:00 p.m.</span>
      </div>
      <div className="event-timeline-item">
        <span className="event-timeline-label">Wedding Dinner</span>
        <span className="event-timeline-time">6:00 p.m.</span>
      </div>
      <div className="event-timeline-item">
        <span className="event-timeline-label">Cake Cutting</span>
        <span className="event-timeline-time"><PuzzleFact factId="cake-time" /></span>
      </div>
      <div className="event-timeline-item">
        <span className="event-timeline-label">Dance Party</span>
        <span className="event-timeline-time">9:00 p.m.</span>
      </div>
    </div>
  </div>
);

const FoodMenu = () => (
  <div className="food-menu">
    <h3 className="food-menu-title">Menu</h3>
    
    <div className="food-menu-course">
      <h4 className="food-menu-course-title">Starter</h4>
      <p className="food-menu-item">Pressed Pigeon, Wild mushroom, <PuzzleFact factId="menu-seed" />, port glaze vinaigrette</p>
      <p className="food-menu-item">Dressed Portland crab, pink grapefruit, endive salad</p>
    </div>

    <div className="food-menu-course">
      <h4 className="food-menu-course-title">Main</h4>
      <p className="food-menu-item">Aberdeen angus beef loin, grain mustard potatoes, buttered turnips, port jus</p>
      <p className="food-menu-item">Brill Meuniere, wilted sea greens, herb beurre blanc</p>
    </div>

    <div className="food-menu-course">
      <h4 className="food-menu-course-title">Dessert</h4>
      <p className="food-menu-item">Chocolate, lime parfait (v)</p>
      <p className="food-menu-item"><PuzzleFact factId="decoy-dessert" /></p>
    </div>
  </div>
);

const Details = () => {
  const navigate = useNavigate();

  const handleViewMap = (e) => {
    e.preventDefault();
    navigate('/map');
  };

  return (
    <section id="details" className="details-section">
      <div className="details-content">
        <h2 className="details-title">The Special Day</h2>
        
        <EventInfo onViewMap={handleViewMap} />
        
        <EventTimeline />

        <div className="details-divider"></div>

        <FoodMenu />
      </div>
    </section>
  );
};

export default Details;
